<template>
	<v-col class="ma-0 pa-0" cols="12" id="head_title">
		<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
			<v-row class="ma-0 pa-0" align="center" justify="space-between" id="header_height">
				<!-- 좌측: 카메라리스트 / 분할화면 탭 -->
				<v-row class="ma-0 pa-0" align="center">
					<v-btn width="9rem" height="50px" class="ma-0 pa-0" id="header_btn1" elevation="0"
						@click="$emit('tabChange', 0)" :class="{ 'current_btn': tab == 0 }">
						{{ 'カメラリスト' }}
					</v-btn>
					<v-btn width="9rem" height="50px" class="ma-0 pa-0" id="header_btn2" elevation="0"
						@click="$emit('tabChange', 1)" :class="{ 'current_btn': tab == 1 }">
						{{ '分割画面' }}
					</v-btn>
				</v-row>
				<!-- 우측: 공유사용자추가 / 설정(톱니바퀴) -->
				<v-row class="ma-0 pa-0" align="center" justify="end">
					<v-btn width="auto" height="50px" class="back_clean_btn ma-0 pa-0 pl-1 pr-1"
						id="back_clean_btn2" elevation="0" @click="shareUserDialogVisible = true">
						<v-row class="ma-0 pa-0" align="end">
							<v-img max-height="1.5rem" max-width="1.25rem" class="ma-0 pa-0"
								src="@/assets/images/icon_user.png"></v-img>
							<v-col class="ma-0 pa-0 pl-1" cols="auto" style="color:#979FB1;">
								{{ t('total') + shareUserCount + t('peopleInTotal') }}
							</v-col>
							<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0"
								src="@/assets/images/corner_bottom_arrow.png"></v-img>
						</v-row>
					</v-btn>
					<v-menu offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-btn width="auto" height="50px" class="back_clean_btn ma-0 pa-0 pl-1 pr-1 ml-5"
								id="back_clean_btn3" elevation="0" v-bind="attrs" v-on="on">
								<v-img max-height="1.75rem" max-width="1.75rem" class="ma-0 pa-0"
									src="@/assets/images/cog_corner_arrow.png"></v-img>
							</v-btn>
						</template>
						<v-list class="ma-0 pa-0">
							<v-list-item class="ma-0 pa-2" @click="editNameDialogVisible = true"
								style="border-bottom: 1px solid #4A4A4A;">
								<v-list-item-title class="list_font">{{ 'グループ名変更' }}</v-list-item-title>
							</v-list-item>
							<v-list-item class="ma-0 pa-2" @click="requestDeleteGroup">
								<v-list-item-title class="list_font">{{ 'グループ削除' }}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</v-row>
			</v-row>
		</v-col>

		<CameraGroupShareUserDialog :dialogVisible="shareUserDialogVisible" :group="currentGroup"
			:shareUsers="shareUserList"
			@visible="shareUserDialogVisibleFunc" @update="shareUserUpdateFunc" />
		<CameraGroupNameDialog :dialogVisible="editNameDialogVisible" :group="currentGroup"
			@visible="editNameDialogVisibleFunc" @success="groupNameChangeSuccessFunc" />
	</v-col>
</template>

<script>
import mixin from '@/mixin';
import CameraGroupShareUserDialog from '@/components/dialogs/CameraGroupShareUserDialog.vue';
import CameraGroupNameDialog from '@/components/dialogs/CameraGroupNameDialog.vue';
export default {
	props: {
		tab: { type: Number, default: 0 }, // 0: 카메라리스트, 1: 분할화면
	},
	components: {
		CameraGroupShareUserDialog, CameraGroupNameDialog
	},
	mixins: [mixin.common],
	data: () => ({
		currentGroupId: '',
		currentGroup: null,
		shareUserDialogVisible: false,
		editNameDialogVisible: false,
		shareUserList: [],   // 공유 사용자 목록
		shareUserCount: 0,   // 공유 중인 사용자 수 (버튼 표시용)
	}),
	watch: {
		'$route.query.groupId': function (val) {
			this.currentGroupId = val;
			this.fetchGroupData();
		}
	},
	created() {
		this.currentGroupId = this.$route.query.groupId;
	},
	mounted() {
		this.fetchGroupData();
	},
	methods: {
		fetchGroupData() {
			if (!this.currentGroupId) return;
			this.networkController.getCameraCheckListGroup({}, this.currentGroupId)
				.then((res) => {
					console.log('%cCamera Group Detail\n', "color:#008DD0;", res.data);
					this.currentGroup = res.data;
					this.$emit('currentGroup', res.data);
				}).catch(() => { });
			this.fetchShareUsers();
		},
		// 카메라그룹 공유 사용자 목록 조회 → 버튼에 인원수 표시 + 다이얼로그 초기 목록으로 전달
		fetchShareUsers() {
			if (!this.currentGroupId) return;
			this.networkController.getCameraGroupShareUser({}, this.currentGroupId)
				.then((res) => {
					const list = (res && res.data) || [];
					this.shareUserList = list;
					this.shareUserCount = list.length;
				}).catch(() => { });
		},
		// 카메라그룹 목록(좌측 네비)을 갱신한다.
		refreshCameraGroupList() {
			this.networkController.getCameraGroupList({}).then((res) => {
				this.$store.commit('setCameraGroupList', (res && res.data) || []);
			}).catch(() => { });
		},
		shareUserDialogVisibleFunc(visible) {
			this.shareUserDialogVisible = visible;
		},
		shareUserUpdateFunc() {
			// 등록/삭제 반영 후 서버에서 공유 사용자 목록/인원수를 재조회한다.
			this.fetchShareUsers();
		},
		editNameDialogVisibleFunc(visible) {
			this.editNameDialogVisible = visible;
		},
		groupNameChangeSuccessFunc(newName) {
			if (this.currentGroup) this.currentGroup.groupName = newName;
			this.refreshCameraGroupList();
			this.$emit('currentGroup', this.currentGroup);
		},
		async requestDeleteGroup() {
			await this.$dialog.confirm({
				title: this.tcb('deleteGroupTitle'),
				text: 'カメラグループを削除します。よろしいですか？',
				actions: {
					false: { color: 'white', text: this.t('cancel') },
					true: {
						color: '#008DD0', text: this.t('confirm'),
						handle: async () => {
							this.$vloading.show();
							await this.networkController.deleteCameraCheckListGroup({}, this.currentGroupId)
								.then(() => {
									this.refreshCameraGroupList();
									this.$vloading.hide();
									this.showToastMessage(this.tmb('requestSuccess'));
									this.replaceRoute('/dashboard', {});
								}).catch(() => {
									this.$vloading.hide();
								});
						}
					}
				}
			});
		},
	}
}
</script>

<style lang="scss" scoped>
#head_title {
	position: sticky;
	top: 0;
	z-index: 5;
	background-color: #272A33;
}
#header_height {
	height: 50px;
}
#header_btn1, #header_btn2 {
	color: #979FB1;
	border-bottom: 1px solid #484848;
	background-color: transparent;
	min-width: 1rem;
}
.current_btn {
	color: white !important;
	background-color: transparent;
	min-width: 1rem;
	border-bottom: 4px solid #008DD0 !important;
}
.back_clean_btn {
	background-color: transparent !important;
	min-width: 1rem;
	color: white;
}
.list_font {
	font-size: 0.8rem;
	font-weight: bold;
}
.v-list {
	background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
	.v-list-item {
		min-height: 0px;
		color: white !important;
	}
	.v-list-item__content {
		color: white;
		padding: 5px 0;
	}
}
</style>
